import { render, staticRenderFns } from "./DepartmentDashboard.vue?vue&type=template&id=699d6da8&scoped=true&"
import script from "./DepartmentDashboard.vue?vue&type=script&lang=js&"
export * from "./DepartmentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentDashboard.vue?vue&type=style&index=0&id=699d6da8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699d6da8",
  null
  
)

export default component.exports